import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';
import { performAction } from '../../actions';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './Hooi_Default.module.css';
import { DoubleCheck } from '../../../../containers/App/Components/DoubleCheck/DoubleCheck';
import { VehicleEditableField } from '../../../Vehicles/components/VehicleEditableField';

const TASK_REMARK_TYPE = 'HOOI_NEW_task_order_key_program_dealer';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }
`;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_NEW_order_key_program_hooikammerComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return [
      'HOOI_NEW_order_key_program_dealer_ready',
      'HOOI_NEW_order_key_transport_to_steenwijk',
      'HOOI_NEW_order_key_change_location',
    ];
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    let disable = false;

    this.doubleCheckProps.forEach(prop => {
      if (this.props.vehicle?.[prop] !== '0') {
        disable = true;
      }
    });

    return disable;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  {['TDN_present'].map(name => (
                    <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} yesNo />
                  ))}
                </Cell>
              </Row>
              {this.propertyValue('TDN_present') == '1' && (
                <>
                  <Row>
                    <Cell>
                      {['hooikammer_order_key'].map(name => (
                        <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                      ))}
                    </Cell>
                  </Row>
                  {this.propertyValue('hooikammer_order_key') === '1' && (
                    <Row>
                      <Cell>
                        <VehicleEditableField
                          name={'hooikammer_order_key_dealer'}
                          inputType={'textarea'}
                          vehicle={this.props.vehicle}
                        />
                      </Cell>
                    </Row>
                  )}
                  {this.propertyValue('hooikammer_order_key_dealer') && (
                    <Row>
                      <Cell>
                        {['hooikammer_order_key_dealer_status'].map(name => (
                          <DoubleCheck
                            key={name}
                            name={name}
                            vehicle={this.props.vehicle}
                            customYes={'Besteld'}
                            customNo={'Niet besteld'}
                          />
                        ))}
                      </Cell>
                    </Row>
                  )}

                  {this.propertyValue('hooikammer_order_key_dealer_status') === '1' && (
                    <Row>
                      <Cell>
                        {['hooikammer_key_received_from_dealer'].map(name => (
                          <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                        ))}
                      </Cell>
                    </Row>
                  )}
                  {this.propertyValue('hooikammer_key_received_from_dealer') === '1' && (
                    <Row>
                      <Cell>
                        {['hooikammer_key_received_from_dealer_hooikammer'].map(name => (
                          <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                        ))}
                      </Cell>
                    </Row>
                  )}

                  {this.propertyValue('hooikammer_key_received_from_dealer_hooikammer') === '1' && (
                    <Row>
                      <Cell>
                        {['hooikammer_is_the_car_drivable'].map(name => (
                          <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                        ))}
                      </Cell>
                    </Row>
                  )}

                  {this.propertyValue('is_the_car_drivable') === '0' && (
                    <>
                      <Row>
                        <Cell>
                          {['hooikammer_start_new_task_key_order'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                    </>
                  )}
                </>
              )}
              {this.propertyValue('TDN_present') == '0' && (
                <>
                  <Row>
                    <Cell>
                      {['TDN_available'].map(name => (
                        <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                      ))}
                    </Cell>
                  </Row>
                  {this.propertyValue('TDN_available') == '1' && (
                    <>
                      <Row>
                        <Cell>
                          <VehicleEditableField
                            name={'reason_key_not_orderable'}
                            inputType={'textarea'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                      <Row>
                        <Cell>
                          <DoubleCheck
                            name={'reason_key_not_orderable_status'}
                            vehicle={this.props.vehicle}
                            customYes={'To be done'}
                            customNo={'Waiting for follow up'}
                          />
                        </Cell>
                      </Row>
                      <Row>
                        <Cell>
                          <VehicleEditableField
                            name={'TDN_client_feedback'}
                            inputType={'textarea'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                    </>
                  )}
                  {this.propertyValue('TDN_available') == '0' && (
                    <>
                      <Row>
                        <Cell>
                          <DoubleCheck name={'TDN_message_to_client'} vehicle={this.props.vehicle} />
                        </Cell>
                      </Row>
                      {this.propertyValue('TDN_message_to_client') === '1' && (
                        <Row>
                          <Cell>
                            <DoubleCheck
                              name={'TDN_requested'}
                              vehicle={this.props.vehicle}
                              customYes={'To be done'}
                              customNo={'Waiting for follow up'}
                            />
                          </Cell>
                        </Row>
                      )}
                      {this.propertyValue('TDN_requested') === '1' && (
                        <Row>
                          <Cell>
                            <DoubleCheck name={'TDN_ontvangen_en_pdf_gesfuurd_naar_dealer'} vehicle={this.props.vehicle} />
                          </Cell>
                        </Row>
                      )}
                      <Row>
                        <Cell>
                          <VehicleEditableField
                            name={'TDN_client_feedback'}
                            inputType={'textarea'}
                            vehicle={this.props.vehicle}
                          />
                        </Cell>
                      </Row>
                    </>
                  )}
                  {this.propertyValue('HOOI_NEW_TDN_available') == '0' && (
                    <>
                      <Row>
                        <Cell>
                          {['HOOI_NEW_mail_TDN'].map(name => (
                            <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                          ))}
                        </Cell>
                      </Row>
                    </>
                  )}
                </>
              )}
              <HBox className="mt-3">
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    key={'modal'}
                    fullWidth={true}
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
              </HBox>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_NEW_order_key_program_hooikammerComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_NEW_order_key_program_hooikammer = compose(
  withConnect,
  withRouter,
)(HOOI_NEW_order_key_program_hooikammerComp);
